module.exports = __webpack_public_path__ + "img/ico-facebook.32c3ef9d.svg";